import { call, put, takeLatest } from 'redux-saga/effects';

import { StatusCode } from '@/constants/API';
import SERVICES from '@/services';

import {
  getSnapshotListFailure,
  getSnapshotListRequest,
  getSnapshotListSuccess,
  revertSnapshotFailure,
  revertSnapshotRequest,
  revertSnapshotSuccess,
} from '../slices/snapshot/snapshot';

type IPayload = Record<string, any>;

function* getSnapshotListFlow({ payload }: IPayload): any {
  try {
    const response = yield call(SERVICES.getSnapshots, payload);

    if (response.status === StatusCode.SUCCESS_COMMON) {
      yield put({
        type: getSnapshotListSuccess.type,
        payload: response.data,
      });
    } else {
      yield put({ type: getSnapshotListFailure.type });
    }
  } catch (error) {
    yield put({ type: getSnapshotListFailure.type });
  }
}

function* handleRevertSnapshot({ payload }: IPayload): any {
  try {
    const response = yield call(
      payload?.isV2 ? SERVICES.revertSnapshotV2 : SERVICES.revertSnapshotV1,
      { snapshotId: payload?.snapshotId },
    );

    const successStatuses = [StatusCode.NO_CONTENT, StatusCode.SUCCESS_COMMON];

    if (successStatuses.includes(response.status)) {
      yield put({
        type: revertSnapshotSuccess.type,
        payload: response.data,
      });
    } else {
      yield put({ type: revertSnapshotFailure.type });
    }
  } catch (error) {
    yield put({ type: revertSnapshotFailure.type });
  }
}

function* snapshotSaga() {
  yield takeLatest(getSnapshotListRequest, getSnapshotListFlow);
  yield takeLatest(revertSnapshotRequest, handleRevertSnapshot);
}

export default snapshotSaga;
